import type { RemoveBgOpts } from '~/types/pipeline';
import type { BgApi } from '~/workers/bg.worker';
import { makeWorkerSingleton } from './comlink-worker';

const bg = makeWorkerSingleton<BgApi>(
  () => new Worker(new URL('../workers/bg.worker.ts', import.meta.url), { type: 'module' }),
);

if (import.meta.hot) import.meta.hot.dispose(bg.dispose);

export function removeBackgroundViaWorker(
  image: ImageData,
  opts: RemoveBgOpts,
): Promise<ImageData> {
  return bg.get().removeBackground(image, opts);
}
